import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-x-8" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "mt-2 text-xs/5 text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCircleIcon = _resolveComponent("UserCircleIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.file === null && _ctx.current_url === null)
      ? (_openBlock(), _createBlock(_component_UserCircleIcon, {
          key: 0,
          class: "size-12 text-gray-300",
          "aria-hidden": "true"
        }))
      : _createCommentVNode("", true),
    (_ctx.file !== null)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _ctx.preview_url,
          class: "size-24 flex-none rounded-full bg-gray-800 object-cover",
          alt: ""
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.file === null && _ctx.current_url !== null)
      ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          src: _ctx.current_url,
          class: "size-24 flex-none rounded-full bg-gray-800 object-cover",
          alt: ""
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickSelectFile && _ctx.clickSelectFile(...args)), ["prevent"])),
        class: "rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 cursor-pointer"
      }, _toDisplayString(_ctx.$t('avatar.change_button')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('avatar.file_info')), 1)
    ]),
    _createElementVNode("input", {
      type: "file",
      accept: "image/*",
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectFile && _ctx.selectFile(...args))),
      name: "avatar",
      ref: "avatar-uploader-input",
      class: "hidden"
    }, null, 544)
  ]))
}